/**
 * Lese-Schicht für den Makro-Brief (v5_macro_brief, Cron-befüllt).
 */

import { supabase } from '@/lib/supabase';
import type { MacroScenario } from '@/lib/macro-brief';

export interface MacroBriefRow {
  brief_date: string;
  kernaussage: string;
  entwicklung: string | null;
  tagesrauschen: string | null;
  szenarien: MacroScenario[];
  model: string | null;
}

/** Neueste Wochen-Linie (Sonntags-Verdichtung) — fürs Langfrist-Gedächtnis im UI. */
export async function fetchLatestWeeklyLine(): Promise<{
  brief_date: string;
  kernaussage: string;
} | null> {
  const { data, error } = await supabase
    .from('v5_macro_brief')
    .select('brief_date, kernaussage')
    .eq('scope', 'weekly')
    .order('brief_date', { ascending: false })
    .limit(1);
  if (error) throw new Error(error.message);
  return (data?.[0] as { brief_date: string; kernaussage: string } | undefined) ?? null;
}

export async function fetchLatestMacroBrief(): Promise<MacroBriefRow | null> {
  const { data, error } = await supabase
    .from('v5_macro_brief')
    .select('brief_date, kernaussage, entwicklung, tagesrauschen, szenarien, model')
    .eq('scope', 'daily')
    .order('brief_date', { ascending: false })
    .limit(1);
  if (error) throw new Error(error.message);
  const row = data?.[0];
  if (!row) return null;
  return {
    ...row,
    szenarien: Array.isArray(row.szenarien) ? (row.szenarien as MacroScenario[]) : [],
  } as MacroBriefRow;
}
